import React, { Fragment, Component } from 'react';
import styled from 'styled-components';
import { Button, SvgIcons, Form, Dropdown, renderAlertBanner } from 'synapsefi-dev-ui';
import { get } from 'lodash';
import HeaderText from '../../../common/HeaderText';
import CopyText from '../../../common/CopyText';
import { preAuthTransaction, reverseTransaction } from '../utils/api';
import { ReactComponent as check_circle} from '../../../../assets/svgs/CircleCheck.svg';
import { ReactComponent as x_filled_circle} from '../../../../assets/svgs/CircleX.svg';
import CustomNumberInput from './CustomNumberInput';
import { getCurrencyOpt, toCents, traverseData } from '../utils/format';

const ResponseContainer = styled.div`
    display: flex;
    font-family: Nunito Sans, sans-serif;
    flex-direction: column;
    align-items: center;
    min-width: 300px;
    justify-content: space-between;
    height: auto;
    width: 415px;
    box-sizing: border-box;
`;

const CheckIcon = styled(check_circle)`
    margin-top: -1px;
    margin-right: 5px;
    width: 24px;
    height: 24px;
`;

const FailedIcon = styled(x_filled_circle)`
    margin-top: -1px;
    margin-right: 5px;
    width: 24px;
    height: 24px;
`

const ResponseHeaderGroup = styled.div`
    display: flex;
    font-family: Nunito Sans, sans-serif;
    align-items: center;
    flex-direction: column;
    text-align: center;
   // padding: ${props => props.isPreAuth ? '0px 100px' : '30px 0px 100px'};
`;

const ResponseHeader = styled.span`
    display: flex;
    align-items: center;
    font-size: 24px;
`;

const ResponseAmount = styled.span`
    font-size: 32px;
    margin-bottom: ${props => props.isPreAuth ? '20px' : '40px'};
`;

const ResponseBtn = styled(Button)`
    max-width: fit-content;
    padding: 0px 16px;

    .syn-dev-ui-button-focus-container {
        font-size: 14px;
        height: 32px;
        padding: 0px;
    }
`;

const CurrencyContainer = styled.div`
    display: grid;
    grid-template-columns: 80px 1fr;
    grid-column-gap: 5px;
`;

const ResponseDetailGroup = styled.div`
    white-space: nowrap;
    text-align: center;
    line-height: 31px;
    padding-bottom: 16px;
    width: 260px;
`;

const ResponseDetail = styled.div`
    font-size: 16px;
    font-weight: 600;
    color: #333;
`;

const ActionContainer = styled.div`
    display: grid;
    width: 200px;
`;

const ButtonGroup = styled.div`
    display: grid;
    grid-row-gap: 15px;
`;

class AccountResponse extends Component {
    constructor(props) {
        super(props);
        this.state = {
            finalAmount: props.amount,
            finalCurrency: props.currency || 'USD',
            isLoading: false,
            isCompletedPreAuth: false,
            isCanceledPreAuth: false,
        }
    }

    componentDidMount() {
        const { amount, currency } = this.props;

        this.setState({
            finalAmount: amount,
            finalCurrency: currency || 'USD'
        });
    }

    updateField = (e, value, field) => {
        this.setState({
            [field]: value
        });
    }

    renderHeader = () => {
        const { status, isPreAuth } = this.props;
        const { isCompletedPreAuth, isCanceledPreAuth } = this.state;
        let selectedStatus = isPreAuth && status === 'Payment Successful'
        ? 'Pre-Authorized Hold Successful'
        : status

        if (isCompletedPreAuth) {
            selectedStatus = 'Payment Successful'
        } else if (isCanceledPreAuth) {
            selectedStatus = 'Payment Successfully Reversed'
        }


        return (
            <ResponseHeader isPreAuth={isPreAuth}>
                {
                    selectedStatus.includes('Successful') ?
                    <CheckIcon
                        className="fadeIn"
                    /> :
                    <FailedIcon
                        className="fadeIn"
                    />
                }
                <HeaderText>
                    {selectedStatus}
                </HeaderText>
            </ResponseHeader>
        );
    }

    completePayment = async () => {
        this.setState({
            isLoading: true
        });

        const { updateTransaction } = this.props;
        const { finalAmount, finalCurrency } = this.state;
        const options = {
            transactionID: this.props.transactionID,
            transaction_currency: finalCurrency,
            amount: toCents(finalAmount)
        };

        try {
            const response = await preAuthTransaction(options);
            const dataObj = traverseData(response);

            this.setState({
                isCompletedPreAuth: true,
                finalAmount: finalAmount
            });
            this.onSuccess(dataObj);
            //return response;
        } catch(error) {
            this.onError(error)
        }
    }

    reversePayment = async () => {
        this.setState({
            isLoading: true
        });

        const { updateTransaction } = this.props;
        const options = {
            transactionID: this.props.transactionID
        };

        try {
            const dataObj = await reverseTransaction(options);
            this.setState({
                isCanceledPreAuth: true
            });
            //return dataObj;
        } catch(error) {
            this.onError(error);
        }
    }


    renderAmount = () => {
        const { amount, isPreAuth } = this.props;
        const { isCompletedPreAuth, finalAmount, isCanceledPreAuth } = this.state;

        if (isCompletedPreAuth) {
            return (
                <ResponseAmount isPreAuth={isPreAuth}>
                    ${finalAmount}
                </ResponseAmount>
            )
        } else {
            return (
                <ResponseAmount isPreAuth={isPreAuth}>
                    ${amount}
                </ResponseAmount>
            );
        }

    }

    onSuccess = () => {
        //this.props.handleNewPayment();
        this.setState({
            isLoading: false
        });
    }

    onError = (error) => {
        this.setState({
            isLoading: false
        });

        renderAlertBanner({ type: 'ERROR', message: `There was an error with the transaction, please try again` });
    }

    renderActions = () => {
        const { handleNewPayment, isPreAuth } = this.props;
        const { isCompletedPreAuth, renderActions, isCanceledPreAuth, isLoading, finalCurrency, finalAmount } = this.state;

        if (isPreAuth && !isCompletedPreAuth && !isCanceledPreAuth) {
            return (
                <ActionContainer>
                    <CurrencyContainer>
                        <Dropdown
                            searchable
                            value={finalCurrency}
                            label={'Final Amount'}
                            propName='finalCurrency'
                            onChange={this.updateField}
                            options={getCurrencyOpt()}
                            scrollLimit={5}
                            multiselect={false}
                            style={
                                {
                                    borderTopRightRadius: '0px',
                                    borderBottomRightRadius: '0px',
                                }
                            }
                        />
                        <CustomNumberInput
                            style={
                                {
                                    borderTopLeftRadius: '0px',
                                    borderBottomLeftRadius: '0px',
                                    marginLeft: '1px',
                                    width: 'calc(100% - 1px)'
                                }
                            }
                            value={finalAmount}
                            propName='finalAmount'
                            placeholder='Amount'
                            onChange={this.updateField}
                        />
                    </CurrencyContainer>
                    <ButtonGroup>
                        <Button
                            isDisabled={isLoading}
                            isLoading={isLoading}
                            showLoading
                            primary
                            small
                            onClick={this.completePayment}
                        >
                            Complete Payment
                        </Button>
                        <Button
                            isDisabled={isLoading}
                            isLoading={isLoading}
                            showLoading
                            className='button--error'
                            secondary
                            small
                            onClick={this.reversePayment}
                        >
                            Reverse Payment
                        </Button>
                    </ButtonGroup>
                </ActionContainer>
            )
        } else {
            return (
                <ResponseBtn
                    primary
                    onClick={handleNewPayment}
                >
                    New Payment
                </ResponseBtn>
            );
        }
    }

    render() {
        const {
            status,
            transactionID,
            isPreAuth,
        } = this.props;

        return (
            <ResponseContainer
                className="fadeIn"
            >
                <ResponseHeaderGroup isPreAuth={isPreAuth}>
                    { this.renderHeader() }
                    { this.renderAmount() }
                    { this.renderActions() }
                </ResponseHeaderGroup>

                <ResponseDetailGroup>
                    {
                        status === 'Payment Successful' &&
                        <Fragment>
                            <ResponseDetail>
                                Transaction ID:
                            </ResponseDetail>
                            <CopyText
                                text={transactionID}
                            />
                        </Fragment>
                    }
                </ResponseDetailGroup>
            </ResponseContainer>
        );
    }
}

export default AccountResponse;